import { Button, Spinner } from 'react-bootstrap';
import { ConsentContext, ConsentFlows } from '../../context/ConsentContext';
import React, { useContext, useEffect } from 'react';
import { contentfulPropTypes, onboardingPropTypes } from '../../propTypes';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

import { Auth } from 'aws-amplify';
import ReactMarkdown from 'react-markdown';
import { registerReferralInHubspot } from '../../api/Hubspot';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledHR = styled.hr`
  height: 1px;
  margin: 23px 0;
  border-top: solid 1px #afb6b9;
`;

const StyledReactMarkdown = styled(ReactMarkdown)`
  h1 {
    margin-bottom: 25px;
  }
`;

const SuccessContainer = ({ loading, fetched, contentful }) => {
  const navigate = useNavigate();
  const {
    method,
    mpan,
    hasOnboarded,
    setHasRegisterMpanTrustedConsent,
    setHasOnboarded,
    setIsSaving,
    isSaving,
    consentFlow,
  } = useContext(ConsentContext);

  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      await recordFlowProgress(flowSteps.CONNECTING_TO_SMART_METER);
    };
    asyncRecordFlowProgress();
  }, []);

  useEffect(() => {
    const asyncUseEffectMethod = async () => {
      setIsSaving(true);
      const user = await Auth.currentAuthenticatedUser();
      const attributes = {
        'custom:smart_meter_user': 'true',
      };
      await Auth.updateUserAttributes(user, attributes).then(() =>
        recordFlowProgress(flowSteps.CONFIRMATION),
      );
      const referredBy = localStorage.getItem('referral_id');
      if (consentFlow === ConsentFlows.ONBOARDING && referredBy) {
        await registerReferralInHubspot(
          contentful.link,
          user.attributes.email,
          referredBy,
        );
        localStorage.removeItem('referral_id');
      }
      setIsSaving(false);
      setHasRegisterMpanTrustedConsent(false);
      setHasOnboarded(true);
    };
    if (!hasOnboarded) {
      asyncUseEffectMethod().then(() => {});
    }
  }, [mpan, method, setHasOnboarded]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    !loading &&
    fetched && (
      <>
        <h1>{contentful?.title}</h1>
        <p className="mt-3 mb-2">{contentful?.subtitle}</p>
        <StyledHR />
        <StyledReactMarkdown>{contentful?.body}</StyledReactMarkdown>
        <p className="text-center my-2">
          {isSaving ? (
            <Spinner animation="border" />
          ) : (
            <>
              {contentful?.primaryButtonText && (
                <Button
                  type="button"
                  variant="primary"
                  className="mb-3 mt-0 w-100"
                  onClick={() => navigate('/download')}>
                  {contentful.primaryButtonText}
                </Button>
              )}
              {contentful?.secondaryButtonText && (
                <Button
                  type="button"
                  variant="secondary"
                  className="w-100"
                  onClick={() => navigate('/account/overview/welcome')}>
                  {contentful.secondaryButtonText}
                </Button>
              )}
            </>
          )}
        </p>
      </>
    )
  );
};

SuccessContainer.propTypes = {
  ...contentfulPropTypes,
  ...onboardingPropTypes,
};

export default withContentfulTag(SuccessContainer, 'web_app_success_page');
